import { SET_DESCRIPTION_ERROR } from './actionTypes';

export const setDescriptionError = (hasError) => ({
  type: SET_DESCRIPTION_ERROR,
  payload: hasError,
});